// import Swiper JS
import Swiper from 'swiper/bundle';

// import Swiper styles
import 'swiper/css/bundle';

/* swiper */
const swiper = document.querySelectorAll('[data-swiper]');

if (swiper) {
	swiper.forEach(function (element) {
	    const settings = JSON.parse(element.dataset.swiper);
	    new Swiper(element, settings);
	});
};